import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function About() {
  return (
    <main data-testid="about-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="eyebrow">About</div>
      <h1 className="mt-3 font-heading text-5xl sm:text-6xl font-light text-stone-900 tracking-tight">
        Not another clinic. <br />
        <span className="italic text-emerald-900">A studio for the body.</span>
      </h1>

      <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7 space-y-6 text-stone-700 leading-relaxed">
          <p>
            Physiofit Studio was born from a simple idea: recovery deserves the same care and craft as fitness. Too often people are handed a printout of exercises and sent home, or shuttled between generic clinics and unrelated gyms. We do it differently.
          </p>
          <p>
            Our space in T. Nagar houses physiotherapy, rehab and functional fitness under one roof, with a foot spa for restoration in between. Every plan starts with a slow, honest assessment — then we design a treatment path that scales from pain relief to real, sustainable strength.
          </p>
          <p>
            We believe in fewer, better sessions. In evidence-based care that respects your time. And in listening to bodies as carefully as we treat them.
          </p>
        </div>
        <div className="lg:col-span-5">
          <div className="border border-stone-200 bg-stone-50 p-8">
            <div className="eyebrow">Founder note</div>
            <p className="mt-4 text-stone-800 italic leading-relaxed">
              "You should leave every session feeling steadier than you walked in. That's the whole standard."
            </p>
            <p className="mt-6 text-stone-500 text-sm">— Team Physiofit</p>
          </div>
        </div>
      </div>

      <section className="mt-20 grid grid-cols-1 md:grid-cols-4 gap-6">
        {[
          { n: "Evidence-based", d: "Rooted in current physiotherapy research and outcomes." },
          { n: "One-on-one", d: "Never a rotating cast of therapists — you keep the same lead." },
          { n: "Milestone-driven", d: "Clear goals, tested regularly, communicated to you." },
          { n: "Studio-quality", d: "Modern equipment in a calm, well-designed clinical space." },
        ].map((v) => (
          <div key={v.n} className="border border-stone-200 bg-white p-6" data-testid={`about-value-${v.n.toLowerCase().replace(/\s+/g,"-")}`}>
            <div className="font-heading text-xl text-stone-900">{v.n}</div>
            <p className="mt-3 text-stone-600 text-sm leading-relaxed">{v.d}</p>
          </div>
        ))}
      </section>

      <section className="mt-20 border border-stone-200 bg-emerald-950 text-stone-50 p-10 sm:p-14 relative overflow-hidden">
        <div className="absolute inset-0 bg-noise opacity-30 pointer-events-none" />
        <div className="relative">
          <div className="eyebrow" style={{color:"#A7F3D0"}}>Come visit</div>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-light">Walk in for an assessment. Leave with a plan.</h2>
          <Link to="/book" data-testid="about-book" className="mt-8 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-stone-50 text-emerald-950 font-medium hover:bg-white transition-colors duration-200">
            Book an appointment <ArrowUpRight size={18} />
          </Link>
        </div>
      </section>
    </main>
  );
}
